import { ApplicationElement } from '../components/application_element/element.js';
import { timestampToDate } from './helpers.js';

export function smartDateFormatter(timestamp) {
  const ONE_DAY = 86400000;

  const currentDate = new Date();
  const date = timestampToDate(timestamp);
  const distance = currentDate - date;
  let format;

  if (currentDate.getFullYear() !== date.getFullYear()) {
    format = 'date.formats.medium';
  } else if (distance > ONE_DAY) {
    format = 'date.formats.short';
  } else {
    format = 'time.formats.compact';
  }

  return ApplicationElement.i18n.l(format, date);
}
